<template lang="pug">
  .mt-10
    v-card(
      :class="subMsg ? 'pt-3' : '' "  
      flat
      dark
      color="var(--bg-main-color)"  
    )
      v-row(no-gutters).px-2.py-2
        v-col(align="start" :cols="(msg || '').length >= 12 ? 12 : 6" md=6)
          v-row(align="center").ma-0
            .ml-2(v-if="imgSrc")
              v-img.img(width='30', :src='imgSrc')
            h2(v-if='!isMobile').ml-2 {{ msg }}
            h3(v-else).ml-2  {{ msg }}
            h3.orange--text.ml-2(v-if='msgAppend')  {{ msgAppend }}
          v-row(v-if="subMsg").ma-0
            h5.ml-2 {{subMsg}}
        v-col(align="end" )
          v-row(align="center" justify="end").ma-0
            slot(name='buttonAppend') 
      //- v-toolbar.toolbartab(dark flat) 
        template(slot='extension')
      slot(name='extensionBottom')
      slot(name='bottomAppend')
    slot

    loading-status(:had-data='hadData')

</template>

<script>
  export default {
    props: {
      msg: {
        type : String,
        default : null
      },
      msgAppend: {
        type : String,
        default : null
      },
      subMsg: {
        type : String,
        default : null
      }, 
      imgSrc:{
        type: String,
        default : null
      },
      hadData:{
        type: Boolean,
        default: true
      }
    },
    computed : {
      isMobile () {
        return this.$vuetify.breakpoint.mdAndDown
      }
    },
  }
</script> 